import type { AuthMeResponse } from './types.js';
import { adminBasePath } from './base.js';

export class AuthApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = 'AuthApiError';
    this.status = status;
  }
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${adminBasePath()}${path}`, {
    headers: { Accept: 'application/json', ...options?.headers },
    ...options,
  });
  const data = (await response.json().catch(() => ({}))) as Record<string, unknown>;
  if (!response.ok) {
    const message = typeof data.error === 'string' ? data.error : `HTTP ${response.status}`;
    throw new AuthApiError(message, response.status);
  }
  return data as T;
}

export function getMe(): Promise<AuthMeResponse> {
  return request<AuthMeResponse>('/api/me');
}

export function login(username: string, password: string): Promise<AuthMeResponse> {
  return request<AuthMeResponse>('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
}

export async function logout(): Promise<void> {
  const response = await fetch(`${adminBasePath()}/api/logout`, {
    method: 'POST',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok && response.status !== 401) {
    const data = (await response.json().catch(() => ({}))) as Record<string, unknown>;
    throw new AuthApiError(typeof data.error === 'string' ? data.error : `HTTP ${response.status}`, response.status);
  }
}
